import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		cardActions: {
			justifyContent: "center"
		}
	} satisfies Record<string, CSSObject>);
};
